<div class="container">
  <h1 mat-card-title>{{ title }}</h1>
  <mat-dialog-content>
    <table-responsive
      [length]="length"
      (changePage)="changePage($event)"
      (filter)="filter($event)"
      [displayedColumns]="displayedColumnsToSelect"
      [dataSource]="dataSource"
      [configColumns]="configColumns"
      [type]="dataSelect.type"
    ></table-responsive>
  </mat-dialog-content>
  <div
    class="dynamic-field form-button"
    align="end"
    style="margin-top: 20px"
    *ngIf="dataSelect.select"
    (click)="onCancel()"
  >
    <button type="button" mat-raised-button cdkFocusInitial>
      {{ "FECHAR" }}
    </button>
  </div>
</div>
